import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Solution = () => {
  return (
    <section className="py-20 bg-brand-black">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Finally: A Dictionary for <span className="text-brand-yellow">Relationship Language</span>
          </h2>
          <p className="text-gray-400 text-lg">
            The Translation Table is 100 decoder rings for moments that make or break relationships.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
                { title: "The Phrase", desc: '"I\'m fine," "we need to talk," "do what you want"', icon: "FiMessageSquare" },
                { title: "Real Meaning", desc: "The hidden intent and emotion behind the words", icon: "FiUnlock" },
                { title: "What To Say", desc: "Exact scripts that stop fights before they start", icon: "FiMessageCircle" }
            ].map((item, idx) => (
                <div key={idx} className="bg-brand-gray p-8 rounded-xl border border-white/5 hover:border-brand-yellow/50 transition-colors">
                    <div className="w-12 h-12 bg-brand-yellow/10 rounded-full flex items-center justify-center mb-6">
                        <SafeIcon name={item.icon.replace('Fi', '')} className="text-2xl text-brand-yellow" />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                </div>
            ))}
        </div>

        <div className="mt-16 text-center">
            <p className="text-2xl font-serif italic text-white mb-8">
                "No more guessing. No more 'what did they mean by that?' Just clarity."
            </p>
        </div>
      </div>
    </section>
  );
};

export default Solution;